import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsBarChartLineFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

import StudentForm from "./StudentForm";
import StudentsList from "./StudentsList";
import StudentsFilter from "./StudentsFilter";
import StudentBulkForm from "./StudentBulkForm";
import StudentReportModal from "./StudentReportModal";
import { fetchStudents } from "../../../store/middleware";
import { setStudent } from "../../../store/slices/b2b/b2bContracts.slice";

import { FilterUser } from "../companies/styles";

function Students() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { contract, student, students } = useSelector((state) => state.b2bContractsReducer);

  const [showDialog, setShowDialog] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showStudentReport, setShowStudentReport] = useState(false);
  const [showAddStudentForm, setShowAddStudentForm] = useState(false);
  const [showAddStudentBulkForm, setShowAddStudentBulkForm] = useState(false);

  const addNewStudent = () => {
    dispatch(
      setStudent({
        id: "",
        name: "",
        email: "",
        userEmails: [],
        userPhones: [{ phone: "", userPhoneTypeId: "" }],
        address: "",
        countryId: "",
        gender: "",
        birthDate: "",
        timezone: "",
        active: true,
        studentPlanId: "",
        typeLanguage: "",
        studentPlanLanguages: [],
        studentLanguages: [{ languageId: "", isNative: true }],
        studentB2b: {
          allowBuyExtraClasses: false,
          allowChangeCourseFocus: false,
          allowChangeCourseStruct: false,
          allowChangeClassFocus: true,
          allowChangeLingoPlan: false,
          targetClassesPerMonth: "",
          observation: "",
        },
        contractId: contract.id,
        contractPlanId: "",
        contractPlanStudent: { contractPlanId: "" },
        contractStudentId: "",
        classTool: "",
        classToolId: "",
      }),
    );
    setShowAddStudentForm(true);
    setShowAddStudentBulkForm(false);
  };

  const emptyFilter = {
    pageNumber: 1,
    pageSize: 100,
    name: "",
    email: "",
    active: "",
    activePlan: "",
    activeStudent: "",
    status: "",
  };

  const loadInfos = () => {
    const filter = { ...emptyFilter, contractId: contract.id };
    dispatch(fetchStudents(filter));
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const deps = {
    student: student,
    t: t,
    showDialog: showDialog,
    alertMessage: alertMessage,
    setShowAddStudentForm: setShowAddStudentForm,
    setShowAddStudentBulkForm: setShowAddStudentBulkForm,
    setShowStudentReport: setShowStudentReport,
    setShowDialog: setShowDialog,
    setAlertMessage: setAlertMessage,
  };

  return (
    <div>
      {!showAddStudentForm && !showAddStudentBulkForm && (
        <FilterUser>
          <div>
            <div className="button" style={{ height: "55px" }}>
              {/* <button type="button" onClick={addBulkStudent}>
                <i className="fa fa-plus" aria-hidden="true" /> {t("BULK_ADD_STUDENT")}
              </button> */}
              <button style={{ marginLeft: "20px" }} type="button" onClick={addNewStudent}>
                <i className="fa fa-plus" aria-hidden="true" /> {t("ADD_NEW_STUDENT")}
              </button>
            </div>
            <StudentsFilter {...deps} />
          </div>

          <div className="divIndicadores">
            <span>
              <BsBarChartLineFill />
              Indicadores
            </span>
            <span className="indicadorExt">
              Effective
              <span className="indicadorInt">
                {
                  students.filter((item) => item.students[0].studentPlans[0].plan.nameEnglish.includes("Effective"))
                    .length
                }
              </span>
            </span>
            <span className="indicadorExt">
              Essential
              <span className="indicadorInt">
                {
                  students.filter((item) => item.students[0].studentPlans[0].plan.nameEnglish.includes("Essential"))
                    .length
                }
              </span>
            </span>
            <span className="indicadorExt">
              Infinite
              <span className="indicadorInt">
                {
                  students.filter((item) => item.students[0].studentPlans[0].plan.nameEnglish.includes("Infinite"))
                    .length
                }
              </span>
            </span>
          </div>

          <StudentsList {...deps} />
        </FilterUser>
      )}
      {showAddStudentForm && <StudentForm {...deps} />}
      {showAddStudentBulkForm && <StudentBulkForm {...deps} addNewStudent={addNewStudent} />}
      {showStudentReport && <StudentReportModal {...deps} />}
    </div>
  );
}

export default Students;
